import styled from "@emotion/styled";

import { SCMPYoutubeVideo } from "~/components/scmp-youtube-video";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const StyledSCMPYoutubeVideo = styled(SCMPYoutubeVideo)`
  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;
